import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = { class: "job-listing-area pt-120 mb-120" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row g-lg-4 gy-5" }
const _hoisted_9 = { class: "col-lg-12 order-lg-2 order-1" }
const _hoisted_10 = { class: "job-listing-wrrap" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "job-listing-card" }
const _hoisted_13 = { class: "job-top" }
const _hoisted_14 = { class: "job-list-content" }
const _hoisted_15 = {
  class: "company-area",
  style: {"min-width":"fit-content"}
}
const _hoisted_16 = { class: "logo" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "company-details" }
const _hoisted_19 = { class: "name-location" }
const _hoisted_20 = { class: "job-discription" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Salary:", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Application Close:", -1)
const _hoisted_23 = { style: {"line-height":"1.5rem"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Summary: ", -1)
const _hoisted_25 = { class: "job-type-apply" }
const _hoisted_26 = { class: "job-type" }
const _hoisted_27 = { class: "light-green" }
const _hoisted_28 = {
  key: 0,
  class: "apply-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, "Job Listing", 4),
              _hoisted_5
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (job) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: job.id,
                    class: "col-lg-12 mb-30"
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("img", {
                                src: (job.company_logo) ? job.company_logo : '/assets/images/work-pages-logo.png',
                                alt: ""
                              }, null, 8, _hoisted_17)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("h5", null, [
                                  _createVNode(_component_router_link, {
                                    to: _ctx.getJobDetail(job.job_key, job.job_slug)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.job_title) + " lor", 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: '/company-details?company_id=' + job.company_id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.company), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("ul", null, [
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_21,
                                  _createTextVNode(" " + _toDisplayString(job.salary_range), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_22,
                                  _createTextVNode(_toDisplayString(job.expiration), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", _hoisted_23, [
                                  _hoisted_24,
                                  _createTextVNode(_toDisplayString(job.job_description.slice(0, 30)), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(job.working_mode) + " " + _toDisplayString(job.expiration), 1)
                        ]),
                        (!_ctx.isJobExpired(job.expiration))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (_ctx.loggedIn)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "primry-btn-2 y-btn lg-btn",
                                    to: _ctx.getJobDetail(job.job_key, job.job_slug, 'apply')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Apply Now")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: { name: 'login' },
                                    class: "primry-btn-2 y-btn lg-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Login to apply")
                                    ]),
                                    _: 1
                                  }))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}